import React, { useCallback, useEffect, useState, useMemo } from 'react';
import Button from '../../shared/components/ui/Button';
import { useForm } from 'react-hook-form';
import { transformData } from '../../super-admin/utils/transformData';
import Modal from '../../shared/components/ui/Modal';
import { CreatePLC } from '../components/forms/CreatePLC';
import { AddPLCUnit } from '../components/forms/AddPLCUnit';
import {
  createPLCList,
  createPLCUnit,
  getAllBlocks,
  getPlcbyBlockId,
  getPlc,
  getAllAccommodationsByProject,
  getUniversalMeasurementByProject,
  updateplc,
  deletePLC,
  handleCheckPLCDelete
} from '../services/api/implementation/impl';
import { useMutation, useQueries, useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { EditPlcList } from '../components/forms/EditPlcList';
import { EditPlcUnit } from './EditPlcUnit';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import PlcCard from '../components/ui/PlcCard';
import { useSidebar } from '../../shared/contexts/SidebarContext';
// import SecondaryTabbedComponent from '../../shared/components/layout/SecondaryTabbedComponent';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import { ChevronDown, Info, LayoutGrid, List, Plus, Search } from 'lucide-react';
import { createPortal } from 'react-dom';
import editIcon from '../../shared/assets/svg/edit.svg';
import deleteIcon from '../../shared/assets/svg/delete.svg';

export const PLCsDetails = () => {
  const userId = Cookies.get('userId');
  const rawMeasurementUnit = Cookies.get('measurement_type');
  const cookieMeasurementType =
    !rawMeasurementUnit || rawMeasurementUnit === 'null' || rawMeasurementUnit === 'undefined'
      ? 'sq/ft'
      : rawMeasurementUnit;
  const { register } = useForm();
  const [isOpenPLCList, setIsOpenPLCList] = useState(false);
  const [isOpenPLCUnit, setIsOpenPLCUnit] = useState(false);
  const [newBlockId, setNewBlockId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [blocksDynaWithLevels, setBlocksDynaWithLevels] = useState([]);
  const { id: projectId } = useParams();
  const [level_id, setLevelId] = useState();
  const [isOpenEditPlcList, setIsOpenEditPlcList] = useState(false);
  const [plcid, setplcId] = useState('');
  const [iseditplcUnits, setiseditplcUnits] = useState(false);
  const [plcUnitId, setplcUnitId] = useState('');
  const [showCreateBtn, setShowCreateBtn] = useState(true);
  const [canDelete, setCanDelete] = useState(null);
  const [resData, setResData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const blockHeaderRef = React.useRef(null);
  const [blockDropdownRect, setBlockDropdownRect] = useState(null);
  const { collapsed } = useSidebar();
  const [plcDescHoverId, setPlcDescHoverId] = useState(null);
  const [plcViewMode, setPlcViewMode] = useState(() => {
    try {
      const saved = localStorage.getItem('plcListViewMode');
      return saved === 'table' || saved === 'card' ? saved : 'card';
    } catch {
      return 'card';
    }
  });
  const [plcSearchQuery, setPlcSearchQuery] = useState('');

  useEffect(() => {
    try {
      localStorage.setItem('plcListViewMode', plcViewMode);
    } catch {
      /* ignore */
    }
  }, [plcViewMode]);

  // Tertiary tabs (PLC List / PLC in Unit) removed — PLC List table is shown directly.
  // const [activeTab, setActiveTab] = useState('PLC List');
  // const tabbedComponentMetaData = { tabs: ['PLC List', 'PLC in Unit'] };

  const { data: blocksDyna, refetch: refetchBlocks } = useQuery({
    queryKey: ['blocks', projectId],
    queryFn: () => getAllBlocks(projectId),
    enabled: !!projectId
  });

  console.log('blockdyna', blocksDyna);

  const { data: getAllplc, refetch: refetchPLCProject } = useQuery({
    queryKey: ['getAllplc'],
    queryFn: getPlc
  });

  const { data: plc_block_id, refetch: refetchplc_blockid } = useQuery({
    queryKey: ['plc_blockbyid', newBlockId],
    queryFn: () => getPlcbyBlockId(newBlockId),
    enabled: !!newBlockId
  });

  const { data: getAllAccommodation, refetch: refetchaccommodation } = useQuery({
    queryKey: ['getAllAccommodation', projectId],
    queryFn: () => getAllAccommodationsByProject(projectId),
    enabled: !!projectId
  });

  const { data: universalMeasurements = [] } = useQuery({
    queryKey: ['universalMeasurementsByProject', projectId],
    queryFn: () => getUniversalMeasurementByProject(projectId),
    enabled: !!projectId
  });

  console.log({ plc_block_id });

  const { mutate: AddListPLC } = useMutation({
    mutationFn: createPLCList,
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('PLC created successfully');
      setIsOpenPLCList(false);
      refetchPLCProject();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error creating PLC', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error creating PLC');
    }
  });

  const { mutate: UnitPLC } = useMutation({
    mutationFn: (payload) => createPLCUnit(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('PLC unit created successfully');
      setIsOpenPLCUnit(false);
      refetchplc_blockid();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error creating PLC unit', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error creating PLC unit');
    }
  });

  console.log({ plc_block_id });

  // Edit Plc in Units

  const { mutate: handleEditPlcUnits } = useMutation({
    mutationFn: (payload) => createPLCUnit(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('PLC in Units updated successfully');
      setiseditplcUnits(false);
      refetchplc_blockid();
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error in PLC update');
    }
  });

  const { mutate: handleEditplcSubmit } = useMutation({
    mutationFn: (data) => updateplc(plcid, data),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('PLC is updated successfully');
      setIsOpenEditPlcList(false);
      refetchPLCProject();
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error in PLC update');
    }
  });

  // const ListDataFormat = ['id', 'name', 'description', 'blockName', 'actions'];

  const blockUnitQueries = useQueries({
    queries: (Array.isArray(blocksDyna) ? blocksDyna : []).map((block) => ({
      queryKey: ['plc_blockbyid', block.id],
      queryFn: () => getPlcbyBlockId(block.id)
    }))
  });
  const [plcUnitsModal, setPlcUnitsModal] = useState(null);
  const unitsByPlcId = useMemo(() => {
    const map = new Map();
    blockUnitQueries.forEach((q) => {
      (q.data || []).forEach((unit) => {
        const seen = new Set();
        (unit.unitPlcs || []).forEach((up) => {
          const pid = Number(up?.plc?.id ?? up?.plc_id);
          if (!Number.isFinite(pid) || seen.has(pid)) return;
          seen.add(pid);
          if (!map.has(pid)) map.set(pid, []);
          map.get(pid).push({
            id: unit.id,
            unitName: unit.unitName,
            blockName: unit.block?.name || '---'
          });
        });
      });
    });
    return map;
  }, [blockUnitQueries]);
  const unitsLoading = blockUnitQueries.some((q) => q.isLoading);

  const filteredPLCs = useMemo(() => {
    if (!getAllplc) return [];
    return getAllplc.filter((plc) =>
      plc.plc_block_mapping.some((mapping) => mapping.block.projectId === parseInt(projectId))
    );
  }, [getAllplc, projectId]);

  const ListDataFormat = [
    'id',
    'name',
    'description',
    'blockName',
    'mode',
    'price',
    'numericRateUnit',
    'gstInclusive',
    'actions'
  ];

  const ListData = useMemo(() => {
    if (!filteredPLCs) return [];

    return filteredPLCs?.map((plc) => {
      const { id, name, description, mode, price, gstInclusive } = plc;
      const universalMeasurementId = plc?.universal_measurement_id;
      const selectedUm = universalMeasurementId
        ? universalMeasurements.find((um) => Number(um.id) === Number(universalMeasurementId))
        : null;
      const perUnit = parseFloat(selectedUm?.per_unit) || 1;
      const numericDisplayPrice =
        mode === 'numeric' &&
        selectedUm &&
        price != null &&
        price !== '' &&
        !Number.isNaN(Number(price))
          ? (Number(price) * perUnit).toFixed(2)
          : price ?? '';
      const blockNames = new Set();

      plc.plc_block_mapping?.forEach((mapping) => {
        blockNames.add(mapping.block.name);
      });

      return transformData(
        {
          id,
          name,
          description,
          blockName: Array.from(blockNames).join(', '),
          mode: mode || null,
          price: numericDisplayPrice,
          numericRateUnit: selectedUm?.name ? `/${selectedUm.name}` : `/${cookieMeasurementType}`,
          gstInclusive: gstInclusive === true || gstInclusive === 'true',
          actions: 'Actions'
        },
        ListDataFormat
      );
    });
  }, [filteredPLCs, universalMeasurements, cookieMeasurementType]);

  const filteredListData = useMemo(() => {
    const q = plcSearchQuery.trim().toLowerCase();
    if (!q) return ListData || [];
    return (ListData || []).filter((row) => {
      const name = String(row.name || '').toLowerCase();
      const blocks = String(row.blockName || '').toLowerCase();
      return name.includes(q) || blocks.includes(q);
    });
  }, [ListData, plcSearchQuery]);

  console.log({ ListData });

  const UnitDataFormat = [
    'id',
    'blockName',
    'unitName',
    'accommodationName',
    'north',
    'south',
    'east',
    'west',
    'other',
    'actions'
  ];

  const getAccommodationName = (id) => {
    return getAllAccommodation?.find((item) => item.id === id)?.name || '';
  };

  const formatDirectionData = (direction, unit) => {
    const plcNames = unit.unitPlcs
      .filter((plc) => plc.direction === direction)
      ?.map((plc) => plc.plc.name)
      .join(', ');

    const entityNames = unit.entityMappings
      .filter((entity) => entity.direction === direction)
      ?.map((entity) => entity.entity.name)
      .join(', ');

    return [entityNames, plcNames].filter(Boolean).join(' | ');
  };
  console.log('plc_block_id', plc_block_id);

  const UnitData = useMemo(() => {
    if (!plc_block_id) return [];

    const filteredUnits = plc_block_id.filter(
      (unit) =>
        !unit?.accommodation?.accomodationType ||
        unit.accommodation.accomodationType?.toLowerCase() !== 'parking'
    );

    // 2) Transform the filtered units
    return filteredUnits.map((unit) =>
      transformData(
        {
          id: unit.id,
          blockName: unit.block?.name || '---',
          unitName: unit.unitName,
          accommodationName: getAccommodationName(unit.accomodation_id),
          north: formatDirectionData('north', unit),
          south: formatDirectionData('south', unit),
          east: formatDirectionData('east', unit),
          west: formatDirectionData('west', unit),
          other: formatDirectionData('other', unit)
        },
        UnitDataFormat
      )
    );
  }, [plc_block_id, getAllAccommodation]);

  console.log({ blocksDyna });

  // Track page view
  useEffect(() => {
    mixpanel.track('P L Cs Details Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    if (Array.isArray(blocksDyna)) {
      const blocksWithLevels = blocksDyna.filter((block) => block?.levels?.length > 0);
      const sorted = blocksWithLevels.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      sorted.sort((a, b) => a.name.localeCompare(b.name));
      if (sorted.length > 0) {
        setBlocksDynaWithLevels(sorted);
        setNewBlockId(sorted[0].id);
      }
    }
  }, [blocksDyna]);

  const handleOpenPLCList = () => setIsOpenPLCList(!isOpenPLCList);

  const openCreatePlcModal = useCallback(() => {
    mixpanel.track('Add PLC Card Clicked', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
    setIsOpenPLCList(true);
  }, [userId]);
  const handleOpenPLCUnit = () => setIsOpenPLCUnit(!isOpenPLCUnit);

  const handleSelectBlockChange = (event) => {
    const selectedBlockId = event.target.value;
    setNewBlockId(selectedBlockId);
  };

  const AddUnitPLC = (data) => {
    setLevelId(data.level_id);
    UnitPLC(data);
  };

  const handleEditplc = (id) => {
    setplcId(id);
    setIsOpenEditPlcList(true);
  };

  const unitData = UnitData.sort((a, b) =>
    a.unitName.localeCompare(b.unitName, undefined, { numeric: true, sensitivity: 'base' })
  );

  const handleEditUnit = (id) => {
    setplcUnitId(id);
    setiseditplcUnits(!iseditplcUnits);
  };

  // PortalDropdown component
  const PortalDropdown = ({ anchorRect, children, onClose }) => {
    if (!anchorRect) return null;
    return createPortal(
      <div
        className="absolute bg-white border rounded shadow z-[1000]"
        style={{
          position: 'fixed',
          left: anchorRect.left,
          top: anchorRect.bottom,
          minWidth: anchorRect.width,
          maxHeight: '250px',
          overflowY: 'auto'
        }}
        onClick={(e) => e.stopPropagation()}>
        {children}
      </div>,
      document.body
    );
  };

  // Handler to open dropdown and set position
  const handleHeaderDropdownClick = (type, event) => {
    // If clicking the same dropdown that's already open, close it
    if (openDropdown === type) {
      setOpenDropdown(null);
      return;
    }

    if (type === 'block' && blockHeaderRef?.current) {
      setBlockDropdownRect(blockHeaderRef?.current?.getBoundingClientRect());
    }
    setOpenDropdown(type);
  };

  // Handler to close dropdown
  const handleCloseDropdown = () => setOpenDropdown(null);

  // Handler to select block
  const handleSelectDropdownItem = (blockId) => {
    setOpenDropdown(null);
    setNewBlockId(blockId);
  };

  useEffect(() => {
    const allEmpty = plc_block_id?.every(
      (item) =>
        Array.isArray(item.unitPlcs) &&
        item.unitPlcs.length === 0 &&
        Array.isArray(item.entityMappings) &&
        item.entityMappings.length === 0
    );
    setShowCreateBtn(allEmpty);
  }, [plc_block_id]);

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckPLCDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const PLC = filteredPLCs?.find((item) => parseInt(item.id) === parseInt(id));
      const PLCName = PLC?.name || 'PLC';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: PLCName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: PLCName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (id) => deletePLC(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('PLC Deleted Successfully');
      refetchPLCProject();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting PLC', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting PLC');
    }
  });

  const HandleDelete = (data) => {
    handleDeleteFn(data);
  };


  // const handleTabChange = (tabName) => setActiveTab(tabName);

  console.log('unitData', unitData);

  return (
    <>
      {isOpenPLCList && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Create PLC'}
          width={70}
          onClose={() => setIsOpenPLCList(false)}>
          <CreatePLC
            isSubmitting={isSubmitting}
            handleListPLC={AddListPLC}
            onClose={() => setIsOpenPLCList(false)}
          />
        </Modal>
      )}
      {isOpenPLCUnit && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Add PLC to Units'}
          width={70}
          onClose={() => setIsOpenPLCUnit(false)}>
          <AddPLCUnit
            isSubmitting={isSubmitting}
            handleUnitPLC={AddUnitPLC}
            onClose={() => setIsOpenPLCUnit(false)}
            defaultBlockId={newBlockId}
          />
        </Modal>
      )}
      {plcUnitsModal && (
        <Modal
          name={`PLC Details - ${plcUnitsModal.name}`}
          width={40}
          onClose={() => setPlcUnitsModal(null)}>
          {(() => {
            const plc = plcUnitsModal;
            const units = [...(unitsByPlcId.get(Number(plc.id)) || [])].sort(
              (a, b) =>
                `${a.blockName}`.localeCompare(`${b.blockName}`, undefined, { numeric: true }) ||
                `${a.unitName}`.localeCompare(`${b.unitName}`, undefined, { numeric: true })
            );
            const grouped = units.reduce((acc, u) => {
              (acc[u.blockName] = acc[u.blockName] || []).push(u);
              return acc;
            }, {});
            const hasPrice = plc.price != null && plc.price !== '';
            const rateText = !hasPrice
              ? '—'
              : plc.mode === 'percent'
                ? `${parseFloat(Number(plc.price).toFixed(4))}%`
                : `${plc.price}${plc.numericRateUnit || ''}`;
            const gstInclusive = plc.gstInclusive === true || plc.gstInclusive === 'true';
            const details = [
              ['Name', plc.name || '—'],
              [
                'Type',
                plc.mode === 'percent' ? 'Percent' : plc.mode === 'numeric' ? 'Numeric rate' : '—'
              ],
              ['Rate', rateText],
              ['GST', gstInclusive ? 'Inclusive' : 'Exclusive'],
              ['Blocks', plc.blockName || 'No associated blocks'],
              ['Units', unitsLoading ? '…' : units.length]
            ];
            return (
              <div className="flex max-h-[70vh] flex-col gap-5 overflow-y-auto p-4">
                <dl className="grid grid-cols-2 gap-x-6 gap-y-3">
                  {details.map(([label, value]) => (
                    <div key={label} className="min-w-0">
                      <dt className="text-xs font-medium uppercase tracking-wide text-gray-400">
                        {label}
                      </dt>
                      <dd className="mt-0.5 break-words text-sm font-semibold text-gray-800">
                        {value}
                      </dd>
                    </div>
                  ))}
                  {plc.description ? (
                    <div className="col-span-2">
                      <dt className="text-xs font-medium uppercase tracking-wide text-gray-400">
                        Description
                      </dt>
                      <dd className="mt-0.5 text-sm text-gray-700">{plc.description}</dd>
                    </div>
                  ) : null}
                </dl>
                <div className="border-t border-gray-100 pt-4">
                  <p className="mb-3 text-sm font-semibold text-gray-800">Associated units</p>
                  {units.length === 0 ? (
                    <p className="text-sm text-gray-500">No units use this PLC yet.</p>
                  ) : (
                    <div className="flex flex-col gap-4">
                      {Object.entries(grouped).map(([blockName, list]) => (
                        <div key={blockName}>
                          <p className="mb-2 text-sm font-semibold text-gray-700">
                            {blockName}{' '}
                            <span className="font-normal text-gray-400">({list.length})</span>
                          </p>
                          <div className="flex flex-wrap gap-1.5">
                            {list.map((u) => (
                              <span
                                key={u.id}
                                className="rounded-full border border-[#E2E8F0] bg-[#F8FAFC] px-2.5 py-1 text-[12px] font-medium text-[#475569]">
                                {u.unitName}
                              </span>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            );
          })()}
        </Modal>
      )}
      {isOpenEditPlcList && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Edit PLC'}
          width={70}
          onClose={() => setIsOpenEditPlcList(false)}>
          <EditPlcList
            id={plcid}
            isSubmitting={isSubmitting}
            handleEditplcSubmit={handleEditplcSubmit}
            onClose={() => setIsOpenEditPlcList(false)}
          />
        </Modal>
      )}

      {iseditplcUnits && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Edit Plc in Unit'}
          width={70}
          onClose={() => setiseditplcUnits(false)}>
          <EditPlcUnit
            id={plcUnitId}
            isSubmitting={isSubmitting}
            handleEditPlcUnits={handleEditPlcUnits}
            blockId={newBlockId}
            onClose={() => setiseditplcUnits(false)}
          />
        </Modal>
      )}

      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this PLC'}'`}
          onClose={() => setCanDelete(null)}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">Looks like this PLC has dependencies</p>
            <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
              {resData &&
                resData.reason?.map((r, index) => (
                  <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                    {index + 1}.{r}
                    {index < resData.reason.length - 1 ? ', ' : ''}
                  </span>
                ))}
            </div>
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'PLC'}
            onClose={() => setCanDelete(null)}
            data={ListData}
            type={'PLC'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      <div
        className={`w-full flex mt-5 flex-col transition-all duration-300 ease-in-out pl-5 pr-5 bg-gray-100 overflow-hidden `}>
        {/* Tertiary tabs (PLC List / PLC in Unit) — commented; show PLC List directly
        <SecondaryTabbedComponent
          data={tabbedComponentMetaData}
          activePrimary={activeTab}
          onChangePrimaryTab={handleTabChange}
          rounded={true}
        />
        */}

        <div className="fixed bottom-8 right-8 z-50">
          <Button
            displayType="primary"
            onClick={() => {
              mixpanel.track('Add PLC Button Clicked', {
                user_id: userId,
                timestamp: new Date().toISOString()
              });
              handleOpenPLCList();
            }}
            customStyle={{
              borderRadius: '50%',
              width: '50px',
              height: '50px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
            }}>
            <Plus size={24} color="white" />
          </Button>
        </div>

        {/* PLC List: card or table view */}
        <div className="mt-3 flex flex-col gap-3">
          <div className="mb-1 rounded-xl border border-[#E7EBF1] bg-white p-3">
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              <div className="relative w-full md:max-w-[280px]">
                <Search
                  size={16}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]"
                />
                <input
                  type="text"
                  value={plcSearchQuery}
                  onChange={(e) => setPlcSearchQuery(e.target.value)}
                  placeholder="Search PLC name or block"
                  className="w-full rounded-lg border border-[#D8DEE7] bg-[#F8FAFC] py-2 pl-9 pr-3 text-sm text-[#334155] outline-none focus:border-[#2A565E]"
                />
              </div>
              <div className="inline-flex items-center rounded-xl border border-[#DCE3EA] bg-white p-1 shadow-sm w-fit">
                <button
                  type="button"
                  onClick={() => setPlcViewMode('card')}
                  className={`h-9 px-4 rounded-lg inline-flex items-center justify-center gap-1.5 text-[13px] font-semibold transition-colors ${
                    plcViewMode === 'card'
                      ? 'bg-[#EEF2F5] text-[#617087]'
                      : 'text-[#7A879B] hover:text-[#617087]'
                  }`}
                  aria-label="Card view">
                  <LayoutGrid size={14} />
                  <span>Card View</span>
                </button>
                <button
                  type="button"
                  onClick={() => setPlcViewMode('table')}
                  className={`h-9 px-4 rounded-lg inline-flex items-center justify-center gap-1.5 text-[13px] font-semibold transition-colors ${
                    plcViewMode === 'table'
                      ? 'bg-[#EEF2F5] text-[#0F4D52]'
                      : 'text-[#7A879B] hover:text-[#617087]'
                  }`}
                  aria-label="Table view">
                  <List size={14} />
                  <span>Table View</span>
                </button>
              </div>
            </div>
          </div>

          {plcViewMode === 'card' ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 pb-4">
              <button
                type="button"
                onClick={openCreatePlcModal}
                className="rounded-2xl border-2 border-dashed border-[#BFD4D8] bg-white text-[#2A565E] flex flex-col items-center justify-center gap-3 shadow-sm hover:bg-[#F7FBFC] hover:border-[#9EC5CC] transition-colors min-h-[220px]">
                <span className="h-11 w-11 rounded-full bg-[#E8F3F5] flex items-center justify-center">
                  <Plus size={22} />
                </span>
                <span className="text-base font-semibold">Add PLC</span>
              </button>

              {filteredListData && filteredListData.length > 0 ? (
                filteredListData.map((row) => (
                  <PlcCard
                    key={row.id}
                    plc={row}
                    unitCount={unitsLoading ? null : (unitsByPlcId.get(Number(row.id)) || []).length}
                    onViewUnits={() => setPlcUnitsModal(row)}
                    onEdit={handleEditplc}
                    onDelete={handleCheckDelete}
                  />
                ))
              ) : ListData?.length > 0 ? (
                <div className="rounded-2xl border border-dashed border-[#C7D3DE] bg-white sm:col-span-2 flex flex-col items-center justify-center text-center p-10 min-h-[220px]">
                  <p className="text-base font-semibold text-stone-600">No PLCs match your search</p>
                  <p className="text-sm text-stone-500 mt-1">Try a different search term.</p>
                </div>
              ) : (
                <div className="rounded-2xl border border-dashed border-[#C7D3DE] bg-white sm:col-span-2 flex flex-col items-center justify-center text-center p-10 min-h-[220px]">
                  <p className="text-base font-semibold text-stone-600">No PLCs yet</p>
                  <p className="text-sm text-stone-500 mt-1">
                    Use <span className="font-medium text-stone-600">Add PLC</span> or the + button to
                    create one.
                  </p>
                </div>
              )}
            </div>
          ) : (
            <div className="plc-table-container h-[calc(100vh-15rem)] overflow-auto">
              <style>{`
                    .plc-table-container .table-body {
                      position: static !important;
                      overflow-y: visible !important;
                      max-height: none !important;  
                      height: auto !important;
                      top: auto !important;
                      padding-bottom: 0 !important;
                    }
                    .plc-table-container .table-container {
                      height: auto !important;
                    }
                    .plc-table-container > div {
                      height: auto !important;  
                    }
                  `}</style>
              <div className="w-full relative rounded-t-lg">
                <table className="text-left w-full">
                  <thead className="bg-gray-200 !text-gray-600 w-full sticky top-0 z-20">
                    <tr className="font-normal h-[3rem] w-full">
                      <th className="px-4 py-2 border-b font-normal">PLC Type Name</th>
                      <th className="px-4 py-2 border-b font-normal">Associated Block</th>
                      <th className="px-4 py-2 border-b font-normal">Rate based on %</th>
                      <th className="px-4 py-2 border-b font-normal">Rate based on unit</th>
                      <th className="px-4 py-2 border-b font-normal">GST</th>
                      <th className="px-4 py-2 border-b font-normal">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredListData && filteredListData.length > 0 ? (
                      filteredListData.map((row) => (
                        <tr
                          key={row.id}
                          className="border-b hover:bg-gray-50 bg-white h-[3.5rem]">
                          <td className="px-4 py-2">
                            <div className="flex items-center gap-2">
                              <div
                                className="relative inline-flex"
                                onMouseEnter={() => setPlcDescHoverId(row.id)}
                                onMouseLeave={() => setPlcDescHoverId(null)}>
                                <span
                                  className="inline-flex text-gray-500 hover:text-customBlue cursor-help shrink-0"
                                  aria-label="Show description">
                                  <Info size={16} aria-hidden="true" />
                                </span>
                                {plcDescHoverId === row.id &&
                                  (row.description || 'No description') && (
                                    <div className="absolute left-full top-0 ml-1 z-[100] min-w-[180px] max-w-[320px] px-3 py-2 text-sm text-gray-800 bg-white border border-gray-200 rounded-lg shadow-lg whitespace-pre-wrap">
                                      {row.description || 'No description'}
                                    </div>
                                  )}
                              </div>
                              <span>{row.name || '---'}</span>
                            </div>
                          </td>
                          <td className="px-4 py-2">{row.blockName || '---'}</td>
                          <td className="px-4 py-2">
                            {row.mode === 'percent'
                              ? row.price != null && row.price !== ''
                                ? `${row.price}%`
                                : '---'
                              : '---'}
                          </td>
                          <td className="px-4 py-2">
                            {row.mode === 'numeric'
                              ? row.price != null && row.price !== ''
                                ? `${row.price}${row.numericRateUnit || ''}`
                                : '---'
                              : '---'}
                          </td>
                          <td className="px-4 py-2">
                            {row.gstInclusive ? 'Inclusive GST' : 'Exclusive GST'}
                          </td>
                          <td className="px-4 py-2">
                            <div className="flex items-center justify-start gap-3">
                              <div
                                className="cursor-pointer hover:scale-110 transition-all duration-300 action-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEditplc(row.id);
                                }}>
                                <img src={editIcon} alt="edit" />
                              </div>
                              {row.id && (
                                <div
                                  className="cursor-pointer hover:scale-110 transition-all duration-300 action-button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleCheckDelete(row.id);
                                  }}>
                                  <img src={deleteIcon} alt="delete" />
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={5} className="text-center py-10 align-middle">
                          <p className="text-gray-400">
                            {ListData?.length ? 'No PLCs match your search' : 'No data found'}
                          </p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>

        {/* PLC in Unit (hidden while tertiary tabs are off; re-enable with tabs above) */}
        {false && (
          <>
            <div className="  w-full relative rounded-t-lg mt-3 h-[calc(100vh-15rem)] overflow-auto">
              <table className="text-left w-full">
                <thead className="bg-gray-200 !text-gray-600 w-full sticky top-0 z-20">
                  <tr className="font-normal h-[3rem] w-full">
                    <th className="px-4 py-2 border-b font-normal relative" ref={blockHeaderRef}>
                      <span>Block Name</span>
                      <button
                        className="ml-1 align-middle"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleHeaderDropdownClick('block', e);
                        }}>
                        <ChevronDown size={16} />
                      </button>
                      {openDropdown === 'block' && blockDropdownRect && (
                        <PortalDropdown
                          anchorRect={blockDropdownRect}
                          onClose={handleCloseDropdown}>
                          {blocksDynaWithLevels?.map((block) => (
                            <div
                              key={block.id}
                              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                                block.id === newBlockId && 'bg-blue-100'
                              }`}
                              onClick={() => handleSelectDropdownItem(block.id)}>
                              {block.name}
                            </div>
                          ))}
                        </PortalDropdown>
                      )}
                    </th>
                    <th className="px-4 py-2 border-b font-normal">Unit Name</th>
                    <th className="px-4 py-2 border-b font-normal">Accommodation</th>
                    <th className="px-4 py-2 border-b font-normal">North</th>
                    <th className="px-4 py-2 border-b font-normal">South</th>
                    <th className="px-4 py-2 border-b font-normal">East</th>
                    <th className="px-4 py-2 border-b font-normal">West</th>
                    <th className="px-4 py-2 border-b font-normal">PLC</th>
                    <th className="px-4 py-2 border-b font-normal">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {unitData && unitData?.length > 0 ? (
                    unitData?.map((item, index) => {
                      // Check if this is the first row or if the block name is different from the previous row
                      const showBlockName =
                        index === 0 || item?.blockName !== unitData[index - 1]?.blockName;

                      return (
                        <tr
                          key={item?.id || index}
                          className="border-b hover:bg-gray-50 bg-white h-[3.5rem]">
                          <td className="px-4 py-2">
                            {showBlockName ? item?.blockName || '---' : ''}
                          </td>
                          <td className="px-4 py-2">{item?.unitName || '---'}</td>
                          <td className="px-4 py-2">{item?.accommodationName || '---'}</td>
                          <td className="px-4 py-2">{item?.north || '---'}</td>
                          <td className="px-4 py-2">{item?.south || '---'}</td>
                          <td className="px-4 py-2">{item?.east || '---'}</td>
                          <td className="px-4 py-2">{item?.west || '---'}</td>
                          <td className="px-4 py-2">{item?.other || '---'}</td>
                          <td className="px-4 py-2">
                            <div className="flex items-center justify-center w-full relative gap-2">
                              <div
                                className="cursor-pointer hover:scale-110 transition-all duration-300 action-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEditUnit(item?.id);
                                }}>
                                <img src={editIcon} alt="edit__icon" />
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center py-10 align-middle">
                        <div className="flex flex-col items-center justify-center w-full h-full">
                          <h2 className="text-lg font-bold text-gray-800 mb-1">No Data Found</h2>
                          <p className="text-gray-600 text-sm">
                            No units found for the selected block.
                            <br />
                            Proceed with adding new units.
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </>
  );
};
